module.exports = __webpack_public_path__ + "img/HP-sec06-image-01-Australia.2186e7a4.svg";